import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { EventCard } from "@/components/EventCard";

export default function EventsPage() {
  const [events, setEvents] = useState(null);
  const [cats, setCats] = useState([]);
  const [params, setParams] = useSearchParams();
  const cat = params.get("category") || "";

  useEffect(() => {
    let alive = true;
    const load = (attempt = 0) =>
      api.get("/events")
        .then((r) => { if (alive) setEvents(r.data); })
        .catch(() => {
          if (alive && attempt < 3) setTimeout(() => load(attempt + 1), 700);
          else if (alive) setEvents([]);
        });
    load();
    api.get("/categories").then((r) => alive && setCats(r.data)).catch(() => {});
    return () => { alive = false; };
  }, []);

  const list = (events || []).filter((e) => !cat || (e.category || "trail-rides") === cat);
  const upcoming = list.filter((e) => new Date(e.date).getTime() >= Date.now());
  const past = list.filter((e) => new Date(e.date).getTime() < Date.now());
  const pick = (id) => setParams(id ? { category: id } : {});

  return (
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 md:py-20">
      <span className="eyebrow">Tickets · VIP · Experiences</span>
      <h1 className="mt-2 font-display text-4xl uppercase text-chrome sm:text-5xl">Events</h1>

      <div className="mt-8 flex flex-wrap gap-2" data-testid="category-filter">
        {[{ id: "", name: "All" }, ...cats].map((c) => (
          <button key={c.id} onClick={() => pick(c.id)} data-testid={`category-filter-${c.id || "all"}`}
            className={`rounded-full px-4 py-2 font-cond text-sm font-bold uppercase tracking-wide transition-colors ${cat === c.id ? "btn-gold" : "border border-neutral-700 text-neutral-300 hover:border-cyan-500 hover:text-cyan-400"}`}>
            {c.name}
          </button>
        ))}
      </div>

      <h2 className="mt-12 font-display text-2xl uppercase text-cyan-400">Upcoming</h2>
      <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-12">
        {upcoming.map((e, i) => (
          <EventCard key={e.slug} event={e} index={i} featured={i === 0 && upcoming.length > 2} />
        ))}
        {events === null && <p className="text-neutral-500">Loading events…</p>}
        {events !== null && !upcoming.length && <p className="text-neutral-500" data-testid="no-upcoming">No upcoming events in this category yet — <a href="/services" className="text-cyan-400">book us to produce yours</a>.</p>}
      </div>

      {past.length > 0 && (
        <>
          <h2 className="mt-16 font-display text-2xl uppercase text-neutral-400">Past Events</h2>
          <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-12">
            {past.map((e, i) => <EventCard key={e.slug} event={e} index={i} />)}
          </div>
        </>
      )}
    </div>
  );
}
